export default __webpack_public_path__ + "static/tsousa-73efb37902c3ef5cfc27484ab07b6929.jpeg";